<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        カードリーダー管理 - 新規登録
        <div class="headerBtn" @click="screenTransition(curdReaderslistPath);" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 登録エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの登録中に問題が発生しました。
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              カードリーダー登録情報
            </div>
            <div class="row">
            <p class="inputTitle editable">機器ID</p>
              <validation-provider name="機器ID" rules="required|deviceId|max:20" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.deviceId"
                   placeholder="20桁以内の半角英数字 例：ABC4EFG2IJK6">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">事業者</p>
              <validation-provider name="事業者" rules="required" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <div class="selectdiv">
                    <select  v-model="selectedCompany">
                      <option value="" selected>事業者を選択</option>
                      <option v-for="Company in optionCompanies"
                      v-bind:value="Company.companyId">
                      {{ Company.companyName }}
                      </option>
                    </select>
                  </div>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">CCUS 現場ID</p>
              <validation-provider name="CCUS 現場ID" rules="required|digits:14" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.ccusSiteId"
                  placeholder="14桁の半角数字 例：13246587902143">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">入退場モード</p>
              <validation-provider name="入退場モード" rules="required" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <div class="selectdiv">
                    <select  v-model="selectedMode">
                      <option value="" selected>入退場モードを選択</option>
                      <option v-for="mode in optionMode"
                      v-bind:value="mode.id">
                      {{ mode.name }}
                      </option>
                    </select>
                  </div>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="buttonGroup">
            <button type="button" class="btn" @click="confirm"
              v-bind:class="{
               disabled: isProcessing() || ObserverProps.invalid || !ObserverProps.validate,
               active: !ObserverProps.invalid && ObserverProps.validate
              }"
              :disabled="ObserverProps.invalid || !ObserverProps.validated">登録
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: 'カードリーダー登録',
  name: 'CurdReaderAdd',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },

  data() {
    return {
      curdReaderslistPath: '/cardReader', // カードリーダー一覧パス
      // 登録用モデル
      detail: {
        deviceId: '',
        companyId: '',
        ccusSiteId: '',
        modeId: '',
      },
      selectedMode: '',     // 選択した入退場モード
      optionMode: [],       // 選択用入退場モード配列
      selectedCompany: '',  // 選択した事業者用
      optionCompanies: [],  // 選択用事業者配列
      // ローディング
      getLodingFlg: false,  // データ取得時ローディング用フラグ
      getErrorFlg: false,   // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false,  // データ登録時エラーフラグ2
      processing: false,
      errorMessage: '',
    };
  },
  // 初期処理
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // 入退場モード一覧取得API呼出
      this.optionMode = await this.callGetModeCategories();
      // 事業者リスト取得API呼出
      this.optionCompanies = await this.callGetCompaniesList();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 入退場モード一覧取得API呼び出し
    async callGetModeCategories() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getModeCategories();
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 事業者リスト取得API呼び出し
    async callGetCompaniesList() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getCompaniesList();
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 登録ボタン押下時処理 カードリーダー新規登録API呼び出し
    async confirm() {
      try {
        // ローディング表示
        this.postLodingFlg = true;
        // エラーフラグ初期化
        this.postErrorFlg = false;
        // カードリーダー新規登録API呼出
        const body =
        [
          {
            deviceId: this.detail.deviceId,
            companyId: this.selectedCompany,
            ccusSiteId: this.detail.ccusSiteId,
            modeId: this.selectedMode,
          },
        ];
        const restResourceService = new ApiClient();
        // 新規登録実行
        await restResourceService.postCardReader(body);
        // カードリーダー一覧画面に戻る
        this.screenTransition(this.curdReaderslistPath);
      } catch (error) {
        this.endProcessing();
        this.errorMessage = error.message;
        this.postErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
    // チャタリング防止
    startProcessing() {
      this.processing = true;
    },
    endProcessing() {
      this.processing = false;
    },
    isProcessing() {
      return this.processing;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

</style>
